import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { MetricCellValueUpdate, MetricExtensionsService } from "../../../api/dataCollectionTypes";
import type { DataSubmissionBlockContent } from "../../../api/inputFormTypes";

interface Props {
  recipientObjectId: string;
  isSubmissionEditable: boolean;
  getBlockContent: (blockId: string) => DataSubmissionBlockContent | undefined;
  metricExtensionsService: MetricExtensionsService;
  onBlockCellValuesEdit: (blockId: string, cellValueUpdates: MetricCellValueUpdate[]) => void;
}

const DataSubmissionFormContext = createContext<Props | undefined>(undefined);

export const DataSubmissionFormContextProvider = ({ children, ...contextValue }: PropsWithChildren<Props>) => (
  <DataSubmissionFormContext value={contextValue}>{children}</DataSubmissionFormContext>
);

export default DataSubmissionFormContext;
